@if (headerLinksNavNode$ | async; as headerLinksNavNode) { @if (isDealerSelector) {
<cx-generic-link [url]="headerLinksNavNode.url">{{ headerLinksNavNode.title }}</cx-generic-link>
} @if (isHeaderLinks) {
<div class="header-links-container js-header-top-menu">
  <div [ngClass]="styleClass$ | async">
      @for (headerEntry of shimanoHeaderNavNode.entries; track headerEntry.url; let i = $index) {
    <nav>
      @if (headerEntry) {
      <cx-generic-link [ngClass]="styleClass$ | async" [url]="headerEntry.url" [style]="headerEntry.styleAttributes">{{
        headerEntry.linkName
      }}</cx-generic-link>
      }
    </nav>
    }
  </div>
</div>
} @if (isMyAccount) {
<app-my-account [myAccountNavNode]="headerLinksNavNode"> </app-my-account>
} }
